import {Exclude, Expose} from 'class-transformer';

@Exclude()
export class CardLoginResponseModel {
  @Expose()
  public token: string;
}
